import { render, staticRenderFns } from "./CentralEntry.vue?vue&type=template&id=59b04d09"
import script from "./CentralEntry.vue?vue&type=script&lang=js"
export * from "./CentralEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports